<script lang="ts">
  import {
    FaqHowCalculated,
    FaqNoSay,
    FaqLiability,
    FaqConfidential,
    FaqWhenPayment,
    FaqHowPayment,
    FaqOtherAccount,
    FaqEasyjetPlus,
    FaqCaseOver,
    FaqWhyFees,
    FaqTaxable,
  } from "./Faq";
</script>

<!-- The same questions apply at every step, in the order of the source FAQ document -->
<div class="ui-accordion">
  <FaqHowCalculated />
  <FaqNoSay />
  <FaqLiability />
  <FaqConfidential />
  <FaqWhenPayment />
  <FaqHowPayment />
  <FaqOtherAccount />
  <FaqEasyjetPlus />
  <FaqCaseOver />
  <FaqWhyFees />
  <FaqTaxable />
</div>
